import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { MessageSquare, X } from 'lucide-react';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // Auto-show after 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // Show on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent('Hello! I\'m interested in your services.');
    window.open(`https://wa.me/14087220122?text=${message}`, '_blank');
  };

  const openTelegram = () => {
    window.open('https://t.me/innodot', '_blank');
  };


  const chatOptions = [
    {
      name: 'WhatsApp',
      icon: (
        <img 
          src="data:image/png;base64,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" 
          alt="WhatsApp" 
          width="56" 
          height="56" 
          className="rounded-full"
        />
      ),
      bgColor: 'bg-transparent',
      action: openWhatsApp,
    },
    {
      name: 'Telegram',
      icon: (
        <svg viewBox="0 0 56 56" width="56" height="56" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="tg-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#2AABEE"/>
              <stop offset="100%" stopColor="#229ED9"/>
            </linearGradient>
          </defs>
          <circle cx="28" cy="28" r="28" fill="url(#tg-grad)"/>
          <path d="M12.5 27.2c7.5-3.3 12.5-5.4 15-6.5 7.1-3 8.6-3.5 9.6-3.5.2 0 .7 0 1 .3.3.2.3.5.4.7 0 .2.1.7 0 1-0.4 4.1-2.1 14-2.9 18.5-.4 1.9-1.1 2.6-1.8 2.6-1.5.1-2.6-1-4.1-1.9-2.3-1.5-3.5-2.4-5.7-3.9-2.5-1.7-.9-2.6.6-4.1.4-.4 7-6.4 7.1-6.9 0-.1 0-.3-.1-.5-.1-.1-.4-.1-.5-.1-.2.1-3.8 2.4-10.8 7.2-1 .7-1.9 1-2.8 1-.9 0-2.7-.5-4-.9-1.6-.5-2.9-.8-2.8-1.7.1-.5.7-.9 1.9-1.4z" fill="white"/>
        </svg>
      ),
      bgColor: 'bg-transparent',
      action: openTelegram,
    },
  ];

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed bottom-20 right-4 z-50"
          initial={{ opacity: 0, scale: 0, y: 100 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0, y: 100 }}
          transition={{ 
            duration: 0.5,
            type: "spring",
            stiffness: 200,
            damping: 20
          }}
        >
          <div className="relative">
            <AnimatePresence>
              {isOpen && (
                <motion.div
                  className="flex flex-col items-center space-y-3 mb-3"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20 }}
                  transition={{ duration: 0.4, staggerChildren: 0.15 }}
                >
                  {chatOptions.map((option, index) => (
                    <motion.button
                      key={option.name}
                      onClick={option.action}
                      className="w-14 h-14 rounded-full focus:outline-none overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
                      aria-label={option.name}
                      initial={{ opacity: 0, scale: 0.5, y: 20 }}
                      animate={{ opacity: 1, scale: 1, y: 0 }}
                      exit={{ opacity: 0, scale: 0.5, y: 20 }}
                      transition={{
                        duration: 0.3,
                        delay: index * 0.1,
                        type: "spring",
                        stiffness: 300,
                        damping: 20
                      }}
                      whileHover={{ 
                        scale: 1.1,
                        rotate: [0, -2, 2, 0],
                        transition: { duration: 0.3 }
                      }}
                      whileTap={{ scale: 0.9 }}
                    >
                      {option.icon}
                    </motion.button>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>

            <motion.button
              onClick={toggleChat}
              className="bg-gradient-to-br from-blue-500 via-blue-600 to-indigo-600 hover:from-blue-600 hover:via-indigo-600 hover:to-purple-600 text-white rounded-full p-4 shadow-xl shadow-blue-500/30 border-2 border-white/20 backdrop-blur-md transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-blue-400/30"
              aria-label="Toggle Chat"
              whileHover={{ 
                scale: 1.15,
                rotate: [0, -5, 5, 0],
                boxShadow: "0 25px 50px rgba(59, 130, 246, 0.5)",
                transition: { duration: 0.3 }
              }}
              whileTap={{ scale: 0.9 }}
              animate={!isOpen ? {
                scale: [1, 1.08, 1],
                boxShadow: [
                  "0 10px 30px rgba(59, 130, 246, 0.3)",
                  "0 20px 40px rgba(59, 130, 246, 0.5)",
                  "0 10px 30px rgba(59, 130, 246, 0.3)"
                ],
                transition: {
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut"
                },
              } : {}}
            >
              <motion.div
                animate={{ rotate: isOpen ? 90 : 0 }}
                transition={{ duration: 0.3 }}
              >
                {isOpen ? <X size={24} /> : <MessageSquare size={24} />}
              </motion.div>
            </motion.button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Chatbot;
